(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bange-collection-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bange-collection-promo')) {
    customElements.define('bange-collection-promo', class extends HTMLElement {
      connectedCallback() {
        this.timer = this.querySelector('[role="timer"]');
        if (this.dataset.timer !== 'true' || !this.timer) return;
        const value = (this.dataset.end || '').trim();
        if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(Z|[+-]\d{2}:\d{2})$/.test(value)) return;
        this.deadline = Date.parse(value);
        if (!Number.isFinite(this.deadline)) return;
        this.updateCountdown();
        if (this.deadline > Date.now()) this.interval = window.setInterval(() => this.updateCountdown(), 1000);
      }
      disconnectedCallback() { window.clearInterval(this.interval); }
      updateCountdown() {
        const remaining = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        if (!remaining) {
          this.timer.hidden = true;
          this.hidden = this.dataset.hideExpired === 'true';
          window.clearInterval(this.interval);
          return;
        }
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        for (const [unit, value] of Object.entries(values)) this.querySelector('[data-unit="' + unit + '"]').textContent = String(value).padStart(2, '0');
        this.timer.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-abstract-collapsible"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-abstract-collapsible')) {
    let abstractSequence = 0;

    customElements.define('product-abstract-collapsible', class extends HTMLElement {
      connectedCallback() {
        this.schedule = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.refresh());
        };

        if (!this.initialized) {
          this.full = this.querySelector('.abstract-full');
          this.preview = this.querySelector('.abstract-preview');
          this.excerpt = this.querySelector('.abstract-excerpt');
          this.tail = this.querySelector('.abstract-tail');
          this.ellipsis = this.querySelector('.abstract-ellipsis');
          this.button = this.querySelector('.abstract-toggle');

          if (!this.full || !this.preview || !this.excerpt || !this.tail || !this.ellipsis || !this.button) return;

          this.full.id = 'product-abstract-full-' + (++abstractSequence);
          this.button.setAttribute('aria-controls', this.full.id);

          const source = this.full.cloneNode(true);
          source.querySelectorAll('br').forEach(node => node.replaceWith(' '));
          source.querySelectorAll('p, div, li, h1, h2, h3, h4, h5, h6').forEach(node => node.append(' '));
          this.text = source.textContent.replace(/\s+/gu, ' ').trim();
          this.characters = typeof Intl.Segmenter === 'function'
            ? Array.from(new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(this.text), item => item.segment)
            : Array.from(this.text);

          this.expanded = false;
          this.collapsible = false;
          this.button.addEventListener('click', () => {
            this.expanded = !this.expanded;
            this.refresh();
          });
          this.initialized = true;
        }

        if (typeof ResizeObserver === 'function') {
          this.observer = new ResizeObserver(entries => {
            const width = entries[0].contentRect.width;
            if (width !== this.lastWidth) {
              this.lastWidth = width;
              this.schedule();
            }
          });
          this.observer.observe(this);
        }

        window.addEventListener('resize', this.schedule);
        document.fonts?.addEventListener('loadingdone', this.schedule);
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.schedule();
        });
        this.schedule();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        window.removeEventListener('resize', this.schedule);
        document.fonts?.removeEventListener('loadingdone', this.schedule);
      }

      refresh() {
        if (!this.initialized || !this.getBoundingClientRect().width) return;

        const measure = this.preview.cloneNode(true);
        measure.classList.add('abstract-measure');
        measure.setAttribute('aria-hidden', 'true');
        measure.setAttribute('inert', '');
        measure.hidden = false;
        measure.style.width = this.getBoundingClientRect().width + 'px';

        const measureButton = measure.querySelector('button');
        measureButton.removeAttribute('aria-controls');
        const measureText = measure.querySelector('.abstract-excerpt');
        const measureTail = measure.querySelector('.abstract-tail');
        const measureEllipsis = measure.querySelector('.abstract-ellipsis');
        measureText.hidden = false;
        measureEllipsis.hidden = false;
        measureText.textContent = this.text;
        measureTail.hidden = true;
        this.append(measure);

        const lineHeight = parseFloat(getComputedStyle(measure).lineHeight);
        const limit = lineHeight * 4 + 0.5;
        this.collapsible = measure.getBoundingClientRect().height > limit;

        if (!this.collapsible) {
          this.expanded = false;
          this.full.hidden = false;
          this.preview.hidden = true;
          this.button.setAttribute('aria-expanded', 'false');
          measure.remove();
          return;
        }

        this.preview.hidden = false;
        this.full.hidden = !this.expanded;
        this.excerpt.hidden = this.expanded;
        this.ellipsis.hidden = this.expanded;
        this.button.setAttribute('aria-expanded', String(this.expanded));
        this.button.textContent = this.expanded ? this.dataset.less : this.dataset.more;

        if (this.expanded) {
          this.tail.hidden = false;
          measure.remove();
          return;
        }

        measureTail.hidden = false;
        let low = 0;
        let high = this.characters.length;

        while (low < high) {
          const middle = Math.ceil((low + high) / 2);
          measureText.textContent = this.characters.slice(0, middle).join('').trimEnd();
          if (measure.getBoundingClientRect().height <= limit) low = middle;
          else high = middle - 1;
        }

        let excerpt = this.characters.slice(0, low).join('').trimEnd();
        if (low < this.characters.length && !/^\s$/u.test(this.characters[low] || '')) {
          const wordEnd = excerpt.lastIndexOf(' ');
          if (wordEnd > 0) excerpt = excerpt.slice(0, wordEnd).trimEnd();
        }

        this.excerpt.textContent = excerpt;
        this.tail.hidden = false;
        measure.remove();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
